<template>
  <div class='d-flex flex-column video-asset-content-wrapper pr-2 pl-2' >
    <div class="video-asset-viewed mt-2" v-if="videoAsset.track_completion">
          <div class="viewed-status" :class="{ 'viewed': videoAssetCompleted, 'not-viewed': !videoAssetCompleted }">
            <i :class="viewedIconClass"></i>
            <span>{{ viewedStatusText }}</span>
          </div>
      </div>
    <slot name="top" :video-asset="videoAsset"></slot>
    <div class="inner-video-asset-content-wrapper row" :class="{'video-asset-content-grid': videoAsset.is_likeable}">
      <div class="video-asset-details col-sm-8">
        <div class="video-asset-content-top-wrapper">
          <slot name="title" :video-asset="videoAsset">
            <div class="video-asset-content-header">
              <h2 class='video-header'>{{ videoAsset.title }}</h2>
              <video-asset-duration
                :video-asset="videoAsset"
              ></video-asset-duration>
            </div>
          </slot>

          <slot name="bookmark" :video-asset="videoAsset">
            <div :class="{'base-bookmarked': videoAsset.bookmarkable}" class='video-card-bookmark-container base-bookmark' v-on:click.stop="toggleBookmark()">
              <i v-if="!!videoAsset.bookmarkable" class="fas fa-bookmark"></i>
              <i v-show="!videoAsset.bookmarkable" class="fal fa-bookmark"></i>
            </div>
          </slot>
        </div>

        <slot name="description" :video-asset="videoAsset">
          <span class='video-description' v-html="videoAsset.description"></span>
        </slot>

        <slot name="plugin" :video-asset="videoAsset">
          <div class="video-asset-plugin-item" v-if="videoAsset.plugin_id && videoAsset.plugin_type" v-cloak>
            <plugin-popup
                :plugin-id="videoAsset.plugin_id"
                :plugin-type="videoAsset.plugin_type"
                :plugin-button="videoAsset.plugin_button_text"
                tabindex="0"
              ></plugin-popup>
          </div>
        </slot>


        <slot name="tags" :video-asset="videoAsset">
          <div class="agenda__item-tags pb-2" v-if="videoAsset.schedule_item_tags">
            <div v-for="(tag, tagIndex) in videoAsset.schedule_item_tags"
              class="badge tag-badge agenda__item-tag"
              v-show="tag.visible"
              :style="`background-color: ${tag.tag_hex};`"
              :data-tag-id="tag.id" :data-tag-name="tag.tag" :key="tagIndex"
            >
              {{ tag.tag }}
            </div>
          </div>
        </slot>

      </div>

     <div class="video-asset-likes session-card-likes col-sm-4" v-if="videoAsset.is_likeable">
        <slot name="likes" :video-asset="videoAsset">
          <!-- Like session -->
          <div class="agenda__item-likeable-item pull-right" v-cloak>
            <likeable-item
              :plugin-type="'VideoAsset'"
              :plugin="videoAsset"
              aria-label="Did you like this video?"
              tabindex="0"
              ></likeable-item>
          </div>
          <!-- /Like session -->
        </slot>
      </div>

      <slot name="speakers" :video-asset="videoAsset">
      <div class='video-asset-speaker-section' v-show="videoAsset.video_asset_speaker_sections ? videoAsset.video_asset_speaker_sections.length : false">
        <div class="pb-1" v-for="(videoAssetSpeakerSection, index) in videoAsset.video_asset_speaker_sections" :key="index">
          <div class='video-asset-speaker-section-name'>
            {{ videoAssetSpeakerSection.name }}
          </div>
          <VideoAssetSpeaker
            v-for="(speaker, i) in videoAssetSpeakerSection.video_asset_speakers"
            :speaker="speaker"
            :key="i"
          />
        </div>
      </div>
    </slot>
    </div>

    <slot name="agenda-items" :video-asset="videoAsset">
      <div class="video-asset-agenda-item" id="agenda-container" v-if="hasAgendaItemAttached">
        <VideoAssetAgendaItem
            :item="videoAssetAgendaItem"
          />
      </div>
    </slot>
    <slot name="bottom" :video-asset="videoAsset"></slot>

  </div>

</template>

<script>
  import VideoAssetSpeaker from '../video-playlists/VideoAssetSpeaker.vue'
  import VideoAssetAgendaItem from '../video-playlists/VideoAssetAgendaItem.vue'
  export default {
    props: {
      videoAsset: {
        type: Object,
        required: true
      },
    },
    components: {
      VideoAssetSpeaker,
      VideoAssetAgendaItem
    },
    computed: {
      hasAgendaItemAttached: function () {
        if (this.videoAssetAgendaItem) {
          return Object.keys(this.videoAssetAgendaItem).length
        }
        else {
          return false
        }
      },

      viewedIconClass() {
      return this.videoAssetCompleted 
        ? 'fas fa-check-circle' 
        : 'far fa-circle';
      },

      viewedStatusText() {
        return this.videoAssetCompleted 
          ? 'Viewed' 
          : 'Not viewed';
      },

      videoAssetCompleted () {
        return this.videoAsset 
          && this.videoAsset.video_asset_completions 
          && this.videoAsset.video_asset_completions.length
      },

      videoAssetAgendaItem: function () {
        if (this.videoAsset) {
          return this.videoAsset.agendaItem
        }
        else {
          return null
        }
      },
    },
    methods: {
      toggleBookmark () {
        window.EventBus.$emit('video-asset-bookmarkable-toggle', this.videoAsset);
      },
    }
  }
</script>

<style scoped>
  .video-asset-content-top-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .video-asset-content-header {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
    gap: 5px;
  }
  .customEvent .video-card-bookmark-container {
    align-self: center;
  }

  .viewed-status {
    display: flex;
    align-items: center;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 15px;
    transition: all 0.3s ease;
  }

  .viewed-status i {
    margin-right: 8px;
    font-size: 1.2em;
  }

  .viewed {
    background-color: #e6f7e6;
    color: #28a745;
    animation: pulse 0.5s ease-in-out;
  }

  .not-viewed {
    background-color: #f8f9fa;
    color: #6c757d;
  }

  .viewed:hover, .not-viewed:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  .viewed-icon {
    animation: iconSpin 0.5s ease-in-out;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes iconSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>